import type { paths } from '@pba/types-openapi-node';
import type { ComplexRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type JoinNodeEventDataObject = paths['/events/{id}/enter']['post']['responses']['201']['content']['application/json'];
type NodeEventEnterBodyRequestParams =
  paths['/events/{id}/enter']['post']['requestBody']['content']['application/json'];
type NodeEventEnterPathRequestParams = paths['/events/{id}/enter']['post']['parameters']['path'];

type NodeEventEnterRequest = ComplexRequest<NodeEventEnterBodyRequestParams, never, NodeEventEnterPathRequestParams>;

export const joinNodeEvent = async ({ body, config, routeParams: { id } }: NodeEventEnterRequest) =>
  nodeApiClient.post<JoinNodeEventDataObject, ApiClientResponse<JoinNodeEventDataObject>>(
    nodeApiRoutes.events.enter(id),
    body,
    config,
  );
